import logger from 'utils/logger.util';

const L = logger('lsGet');

const lsGet = (key, options) => {
  try {
    const value = localStorage.getItem(key);
    
    if (!options?.quiet) L.debug(key, ':', value);

    return value;
  } catch (e) {
    L.warn('lsGet()', e);
    return null;
  }
};

export default lsGet;
